export default __webpack_public_path__ + "static/media/poi.0bb122f6.svg";